import { OKVItemType } from '../OnlineCatalogAssets/types';

interface ProductDeprecatedPlaceholderProps {
  product: string;
  tileType?: OKVItemType;
}
export function ProductDeprecatedPlaceholder({
  product,
  tileType = OKVItemType.Product,
}: Readonly<ProductDeprecatedPlaceholderProps>) {
  return (
    <div className="c-product-tile--deprecated">
      <div>{product}</div>
      <div>{`${capitalizeFirstLetter(tileType)} not available`}</div>
    </div>
  );
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
